import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utility';

const intialState = {
    orders: [ ],
    submitingOrder: false,
    submitingOrderSucess: false,
    submitingOrderFailed: false,
    fetchingOrders: true,
} ;

const reducer = ( state = intialState , action ) => {
    switch( action.type ) {
        case ( actionTypes.SUBMIT_ORDER_INIT ): 
            return updateObject( state , {
                submitingOrderSucess: false,
                submitingOrderFailed: false,
            } )
        case ( actionTypes.SUBMIT_ORDER_START ): 
            return updateObject( state , {
                submitingOrder: true,
                submitingOrderSucess: false,
                submitingOrderFailed: false,
            } )
        case ( actionTypes.SUBMIT_ORDER_SUCCESS ):  
            let updatedOrders = [...state.orders];
            updatedOrders.push(action.submittedOrder);
            return updateObject( state , {
                submitingOrder: false,
                submitingOrderSucess: true,
                orders: updatedOrders,
            } )
        case ( actionTypes.SUBMIT_ORDER_FAILED ):  
            return updateObject( state , {
                submitingOrder: false,
                submitingOrderFailed: true,
            } )
        case ( actionTypes.FETCH_ORDERS_START): 
            return updateObject( state, {
                fetchingOrders: true,
            })
        case ( actionTypes.FETCH_ORDERS_SUCCESS): 
            return updateObject( state, {
                fetchingOrders: false,
                orders: action.orders,
            })
        case ( actionTypes.FETCH_ORDERS_FAILED): 
            return updateObject( state, {
                fetchingOrders: false,
                error: action.error,
            })
        default :  
            return state
    }
}

export default reducer;